import { useEffect, useState } from 'react'
import EmptyBlock from '../../components/common/EmptyBlock'
import TailwindWrapper from '../../components/container/TailwindWrapper'
import useTranslation from '../../modules/i18n/useTranslation'

import { useRouter } from 'next/router'
import apis from '../../modules/apis'
import { axiosPost } from '../../modules/axiosHelper'
import useAppRouter from '../../modules/hooks/common/useAppRouter'
import { s_unsubscribe } from '../../modules/i18n/strings/auto/wording'
import { ICON_CHEVRON_RIGHT_PRIMARY } from '../../modules/svg/svg'
import urls from '../../modules/urls'
import Button from '../_legacy/Button'
import { CheckBox } from '../_legacy/CheckBox'
import Input from '../_legacy/Input'

const orderedKeys = ['NO_INTRESET', 'NO_HELP', 'NO_TIME_OR_COST', 'OTHER_CONTENTS', 'ETC']

const Body = ({ currentUser }) => {
  const { t } = useTranslation()
  const router = useAppRouter()
  const [submitted, setSubmitted] = useState(false)
  const {
    query: { email, lang },
  } = useRouter()
  const initialReasons = [
    {
      value: t(s_unsubscribe.reasons.not_interested),
      checked: false,
      hasDetail: false,
      detail: null,
    },
    {
      value: t(s_unsubscribe.reasons.contents_not_good),
      checked: false,
      hasDetail: false,
      detail: null,
    },
    {
      value: t(s_unsubscribe.reasons.no_time),
      checked: false,
      hasDetail: false,
      detail: null,
    },
    {
      value: t(s_unsubscribe.reasons.other_contents),
      checked: false,
      hasDetail: true,
      detail: null,
    },
    {
      value: t(s_unsubscribe.reasons.other),
      checked: false,
      hasDetail: true,
      detailRequired: true,
      detail: null,
    },
  ]
  const [reasons, setReasons] = useState(initialReasons)
  const toggleCheckedReason = (i) => {
    const newReasons = reasons.map((reason, index) => {
      if (index == i) {
        const { checked, ...rest } = reason
        return { checked: !checked, ...rest }
      }
      return reason
    })
    setReasons(newReasons)
  }
  const setDetail = (i, value) => {
    const newReasons = reasons.map((reason, index) => {
      if (index == i) {
        const { detail, ...rest } = reason
        return { detail: value, ...rest }
      }
      return reason
    })
    setReasons(newReasons)
  }

  const unsubscribe = async () => {
    const unsubscription = await axiosPost(apis.contents_newsletter.unsubscribe(), {
      email,
    })
    if (!unsubscription.success) {
      alert(t(s_unsubscribe.message.failure))
    }
  }

  const submitReasons = async () => {
    if (submitted) return
    if (email) {
      const parsedReasons = {}
      let verified = false
      reasons.forEach((reason, i) => {
        if (reason.checked) {
          if (reason.hasDetail) {
            if (!reason.detail && reason.detailRequired) {
              alert(t(s_unsubscribe.reasons.specify))
              verified = false
            } else {
              verified = true
              parsedReasons[orderedKeys[i]] = reason.detail
            }
          } else {
            verified = true
            parsedReasons[orderedKeys[i]] = true
          }
        }
      })
      if (!verified) {
        alert(t(s_unsubscribe.message.submit_failure))
        return
      }
      const postReason = await axiosPost(apis.contents_newsletter.unsubscribe_reason(), {
        reasons: parsedReasons,
        email,
      })
      if (postReason.success) {
        alert(t(s_unsubscribe.message.success))
        setSubmitted(true)
        setReasons(initialReasons)
      } else {
        alert(t(s_unsubscribe.message.submit_failure))
      }
    } else {
      alert(t(s_unsubscribe.reasons.no_email))
    }
  }

  const resubscribe = async () => {
    if (currentUser) {
      router.push(urls.student.landing.contents.subscribe.index)
    } else {
      router.push(`${urls.student.auth.signIn}?redirect=${urls.student.landing.contents.subscribe.index}`)
    }
  }

  useEffect(() => {
    if (!email) {
      alert(t(s_unsubscribe.reasons.no_email))
    } else {
      unsubscribe()
    }
  }, [])

  return (
    <div>
      <div>
        <div className="mx-auto bg-cover px-[20px] text-center">
          <EmptyBlock h={55} />
          <div className="flex items-center justify-center">
            <div
              style={{ wordBreak: 'keep-all', overflowWrap: 'break-word' }}
              className="max-w-[1000px] text-center text-[32px] font-bold"
            >
              {t(s_unsubscribe.body_header.title)}
            </div>
          </div>
          <EmptyBlock h={36} />

          {!submitted && (
            <>
              <div className="flex items-center justify-center">
                <div className="max-w-[600px] text-center text-[18px] text-gray-700">
                  {t(s_unsubscribe.body_header.subtitle)}
                </div>
              </div>
              <EmptyBlock h={24} />
              <div className="flex items-center justify-center">
                <div className="max-w-[600px]">
                  {reasons.map((item, i) => {
                    return (
                      <div key={i} className="py-[10px]">
                        <div onClick={() => toggleCheckedReason(i)}>
                          <CheckBox checked={item.checked} label={<div className="text-[14px]">{item.value}</div>} />
                        </div>
                        {item.checked && item.hasDetail && (
                          <div className="pl-[36px]">
                            <Input
                              style={{ maxWidth: '500px', marginTop: 10 }}
                              type="text"
                              placeholder={t(s_unsubscribe.reasons.tell_us)}
                              onChange={(value) => setDetail(i, value.target.value)}
                              error={item.detail === '' && item.detailRequired}
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
              <EmptyBlock h={40} />
            </>
          )}
          <div className="flex justify-center">
            <Button
              primary
              onClick={submitReasons}
              disabled={submitted}
              fontSize14
              style={{
                padding: '20px 48.245px',
                lineHeight: 0.1,
              }}
            >
              {submitted ? t(s_unsubscribe.disabled_button) : t(s_unsubscribe.button)}
            </Button>
          </div>
          <EmptyBlock h={24} />
          <div onClick={resubscribe} className="cursor-pointer">
            <span className="text-h5 inline font-medium text-purple-500">
              {t(s_unsubscribe.resubscribe)}
              <img src={ICON_CHEVRON_RIGHT_PRIMARY} className="ml-[8px] inline align-baseline" />
            </span>
          </div>
          <EmptyBlock h={40} />
        </div>
      </div>
    </div>
  )
}

const UnsubscribeBody = ({ currentUser }) => {
  return (
    <>
      <TailwindWrapper>
        <Body currentUser={currentUser} />
      </TailwindWrapper>
    </>
  )
}

export default UnsubscribeBody
